var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-bg"},[_c('div',{staticClass:"lines"},[_c('line-animate',{staticClass:"line1"}),_vm._v(" "),_c('line-animate',{staticClass:"line2"}),_vm._v(" "),_c('line-animate',{staticClass:"line3"})],1),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arr-bg"},[_c('div',{staticClass:"paradigm_sketch__pulse paradigm_sketch__pulse1"}),_vm._v(" "),_c('div',{staticClass:"paradigm_sketch__pulse paradigm_sketch__pulse2"})])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/product/exam/text-bg.vue?vue&type=template&id=dca997a0&scoped=true
// module id = null
// module chunks = 